import { Route, Routes } from 'react-router-dom';
import VehiclesList from './vehicles-list';
import VehiclesItem from './vehicles-item';

const VehiclesRouting = () => {
  return (
    <Routes>
      <Route path='' element={<VehiclesList />} />
      <Route path=':uid' element={<VehiclesItem />} />
    </Routes>
  );
};

export default VehiclesRouting;
